<template>
  <div class="col-md-3 mb-sm-3 mb-md-0">
    <b-list-group role="tablist" class="shadow bg-white h-100 p-b rounded-0">
      <b-list-group-item
        @click="
          page = 'scfv';
          $emit('page', page);
        "
        :class="page == 'scfv' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Detalhes do Grupo
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'usuariosvinculado';
          $emit('page', page);
        "
        :class="page == 'usuariosvinculado' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Usuários Vinculados
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'atividade';
          $emit('page', page);
        "
        :class="page == 'atividade' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Atividades
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'encaminhamento';
          $emit('page', page);
        "
        :class="page == 'encaminhamento' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Encaminhamentos
      </b-list-group-item>

      <b-list-group-item
        v-if="auditoria.length > 0"
        @click="
          page = 'auditoria';
          $emit('page', page);
        "
        :class="page == 'auditoria' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Auditoria
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'comentario';
          $emit('page', page);
        "
        :class="page == 'comentario' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Comentários
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'participacoes';
          $emit('page', page);
        "
        :class="page == 'participacoes' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Participações em Atividades
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
export default {
  props: ["active", "auditoria"],
  data() {
    return { page: "scfv" };
  },
  watch: {
    page: function (val) {
      this.page = val;
    },
  },
  mounted() {
    if (this.active) {
      this.page = this.active;
    }
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
      this.$emit("page", this.page);
    }
  },
  methods: {},
};
</script>
